<template>
<b-taglist>
  <a
    @click="(v) => $emit('toggle', i)"
    :class="[
      'tag', 'is-small', 'a-tag',
      !!activeList.find(a => a === i) ?
        'is-primary' :
        'is-dark'
    ]"
    v-for="i in items"
    :key="i"
    >
      {{i}}
  </a>
</b-taglist>
</template>

<script>
export default {
  props: {
    items: Array,
    activeList: Array,
  },
};
</script>

<style lang="scss" scoped>

.a-tag:hover {
  text-decoration: none;
}
</style>
